var Reverb = window.Reverb || {};
Reverb.Shipping = Reverb.Shipping || {};

Reverb.Shipping.Estimator = (function () {
  var countrySelect = ':input[data-shipping-estimate-field=\'from-countrycode\']';
  var locationSelects = countrySelect + ',:input[data-shipping-estimate-field=\'from-locality\'],:input[data-shipping-estimate-field=\'from-region\']';
  var shippingEstimateData = 'shipping-estimate-field';

  var packagePresetLink = 'a[data-package-preset-link]';
  var shippingEstimateButton = '[data-shipping-estimate-submit]';
  var estimatorContainer = '[data-shipping-estimator-container]';
  var estimatorContents = '[data-shipping-estimator-contents]';
  var estimateForm = '[data-shipping-estimate-form]';

  function hasCompletedLocationFields() {
    return Reverb.Forms.allFieldsValid($(locationSelects));
  }

  function bindDefaultPackageClick() {
    $(document).on('click', packagePresetLink, function (e) {
      e.preventDefault();
      copyDataToForm($(e.target).closest(packagePresetLink));
    });
  }

  function copyDataToForm(linkClicked) {
    $.each(['weight', 'height', 'width', 'length'], function (i, name) {
      var newValue = linkClicked.data('package-' + name);
      setFormField(name, newValue);
    });
  }

  function setFormField(attrName, value) {
    var dataAttrName = attrName.replace('_', '-');
    var input = $(estimatorContainer).find('input[data-' + shippingEstimateData + '=\'' + dataAttrName + '\']');

    input.val(value);
  }

  function bindEstimateButtonClick() {
    $(document).on('click', shippingEstimateButton, handleEstimateButtonClick);
  }

  function handleEstimateButtonClick(event) {
    event.preventDefault();
    var $button = $(event.target);
    var $activeEstimateForm = $button.parents(estimateForm);
    var hasErrors = !validateAndHighlightFields($activeEstimateForm);

    if (hasErrors) {
      event.stopImmediatePropagation();
      Reverb.Forms.enableElement($button);
      return;
    }

    loadEstimateInDom($activeEstimateForm);
  }

  function validateAndHighlightFields($activeEstimateForm) {
    return Reverb.Forms.validateFields($(estimatorContainer), estimateFields($activeEstimateForm));
  }

  function loadEstimateInDom($activeEstimateForm) {
    var $submit = $activeEstimateForm.find(shippingEstimateButton);
    var resultTarget = $($submit.data('estimate-result-target'));
    var url = $submit.data('submit-path');

    showSpinner(resultTarget);

    return $.post(url, toParams($activeEstimateForm)).done(function (returnData) {
      resultTarget.html(returnData);
      resultTarget.removeClass('with-spinner');
    }).fail(function (xhr) {
      resultTarget.html(xhr.responseText);
    }).always(function () {
      Reverb.Forms.enableElement($submit);
    });
  }

  function toParams($activeEstimateForm) {
    var $fields = estimateFields($activeEstimateForm);
    var data = {};
    $fields.each(function (index, element) {
      var $el = $(element);
      var attributeName = $el.data(shippingEstimateData).replace('-', '_');
      var attributeValue = $el.val();
      data[attributeName] = attributeValue;
    });
    return data;
  }

  function showSpinner(target) {
    target.addClass('with-spinner');
    target.html('');
    target.show();
    target.spin({ overlay: false });
  }

  function bindLocationSelectsChange() {
    $(document).on('change', locationSelects, function () {
      showHideEstimator();
    });
  }

  function bindCountrySelectChange() {
    $(document).on('change', countrySelect, function () {
      var $estimatorContents = $(estimatorContents);
      var base_url = $estimatorContents.data('reload-url');
      var url = base_url + '?' + $.param({ from_countrycode: $(this).val() });
      $estimatorContents.load(url);
    });
  }

  function showHideEstimator() {
    var $estimatorContainer = $(estimatorContainer);

    if (hasCompletedLocationFields()) {
      $estimatorContainer.slideDown();
    } else {
      $estimatorContainer.slideUp();
    }
  }

  function estimateFields($activeEstimateForm) {
    var $activeEstimateFormFields = $activeEstimateForm.find('[data-' + shippingEstimateData + ']');
    return $(locationSelects).add($activeEstimateFormFields);
  }

  function init() {
    bindCountrySelectChange();
    bindDefaultPackageClick();
    bindEstimateButtonClick();
    bindLocationSelectsChange();
    showHideEstimator();
  }

  return {
    init: init
  };
})();

$(function () { Reverb.Shipping.Estimator.init(); });



// WEBPACK FOOTER //
// ./javascripts/components/legacy/shipping/estimator.js